import api from '../auth';
const slug = 'api/nis/';

const NiService = () => {
    const getNis = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getNisLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getNi = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteNi = (id) => {
        return api
            .delete(slug + `ni/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createNi = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateNi = (id, data) => {
        return api.put(slug + `ni/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyNi = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getNis,
        getNisLazy,
        getNi,
        deleteNi,
        createNi,
        updateNi,
        getOptions,
        copyNi
    };
};

export default NiService;
